export type ApiGetTechSemanticRequest = string[]

export interface ApiGetTechSemanticResponse {
    [key:string]: string
}

export const GetTechSemantic = Symbol('GetTechSemantic');

export interface GetTechSemantic {
    getTechSemantic(data: ApiGetTechSemanticRequest): Promise<ApiGetTechSemanticResponse>;
}